import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getCertificate,
} from "../../REDUX/Models/certificates.Model";
import Certificate from "../../Components/Certificate";
import Date from "../../Components/Date";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./index.scss";

export default function Verify() {
  const cer_id = useParams().id;

  const [certificate, setCertificate] = useState({});
  const [text, setText] = useState("تحميل");
  const [err, setError] = useState();

const handleClick = async () => {
  const input = document.getElementById("certificate-to-download");

  if (!input) {
    alert("لم يتم العثور على الشهادة");
    return;
  }

  setText("جارٍ التحميل...");

  try {
    await new Promise((res) => setTimeout(res, 200));

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: null,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("landscape", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const pxPerMm = 96 / 25.4;
    const imgWidthMm = canvas.width / pxPerMm;
    const imgHeightMm = canvas.height / pxPerMm;

    const scaleRatio = Math.min(
      pdfWidth / imgWidthMm,
      pdfHeight / imgHeightMm
    );

    const finalWidth = imgWidthMm * scaleRatio;
    const finalHeight = imgHeightMm * scaleRatio;

    const xOffset = (pdfWidth - finalWidth) / 2;
    const yOffset = (pdfHeight - finalHeight) / 2;

    pdf.addImage(imgData, "PNG", xOffset, yOffset, finalWidth, finalHeight);

    pdf.save("twrny-certificate.pdf");
  } catch (error) {
    console.error("PDF export error:", error);
    alert("حدث خطأ أثناء إنشاء الشهادة");
  } finally {
    setText("تحميل");
  }
};


  useEffect(() => {
    getCertificate(cer_id)
      .then((res) => {
        setCertificate(res.data.certificate);
        console.log(res.data.certificate);
      })
      .catch(() => {
        setError("لا يوجد شهادة بهذا الاسم.");
      });
    document.title = `طورنى - تحقق من صحة الشهادة`;
  }, [cer_id]);

return (
<section className="verify">
      <div className="verify__container">
        <div className="verify__row">
          {err ? (
            <span className="verify__error">{err}</span>
          ) : (
            <>
              <header className="verify__header">
                <p>
                  تم استحقاق هذه الشهادة بواسطة:{" "}
                  <span className="verify__name">
                    "{certificate.first_name} {certificate.last_name}"
                  </span>
                  <br />
                  تاريخ الاستحقاق: "<Date date={certificate.created_date} />"
                </p>
              </header>

              <div className="verify__content">
                <div id="certificate-to-download">
                  <Certificate certificateProp={certificate} />
                </div>
                <button
                  className="verify__download-button"
                  onClick={handleClick}
                  disabled={text !== "تحميل"}
                >
                  <i className="fa-duotone fa-download"></i>
                  {text}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};